<script>
import SeniorEditor from '@/components/base/SeniorEditor.vue'
import OptionSeniorInput from '@/question/components/OptionSeniorInput'
import { getImportTemplate, getAttachments, uploadBriefFile } from '@/api/project-task/setting'
import { downloadStream } from '@/assets/js/utils'
import { uploadFile } from '@dygc/shared'

export default {
  name: 'ContentConfig',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Number],
      required: true
    },
    projectId: {
      type: [String, Number],
      required: true
    }
  },
  components: { OptionSeniorInput, SeniorEditor },
  data() {
    return {
      innerTitle: '',
      innerContent: '',
      data: [],
      columns: [],
      tableLoading: false,
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      readonly: true
    }
  },
  created() {
    this.innerTitle = this.title
    this.innerContent = this.content
    this.getList().finally(() => {
    })
  },
  methods: {
    onBlurTitle() {
      this.$emit('update:title', this.innerTitle)
    },
    saveContent() {
      if (this.innerContent === this.content) {
        this.readonly = true
        return
      }
      this.$confirm('当前项目任务书通用文案有修改，确认保存后，责任人将需要重新签署任务书', '提示', {
        confirmButtonText: '确认保存',
        cancelButtonText: '放弃本次修改',
        type: 'warning'
      }).then(()=>{
        this.$emit('update:content', this.innerContent)
        this.readonly = true
      }).catch(()=>{
        this.innerContent = this.content
        this.readonly = true
      })

    },
    getTemplate() {
      getImportTemplate().then(res => {
        downloadStream(res.data, res.headers)
      })
    },
    onUploadFile() {
      uploadFile(Infinity, ['xlsx', 'xls'], {
        accept: '.xls,.xlsx'
      }).then(file => {
        uploadBriefFile(this.projectId, this.type, file).then(res => {
          this.getList()
        })
      })
    },
    getList() {
      this.tableLoading = true
      return getAttachments(this.projectId, this.type, {
        size: this.page.size,
        current: this.page.current
      }).then((res) => {
        const data = res.data.data
        this.columns = data.heads.map(item => {
          return {
            label: item,
            prop: item
          }
        })
        this.data = data.records || []
        this.page.size = data.size
        this.page.current = data.current
        this.page.total = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    onSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    onCurrentChange(val) {
      this.page.current = val
      this.getList()
    }
  },
  computed: {},
  watch:{
    title(val) {
      if (this.innerTitle === val) return
      this.innerTitle = val
    },
    content(val) {
      if (this.innerContent === val) return
      this.innerContent = val
    }
  }
}
</script>

<template>
  <div>
    <div class="content mb-5 title-content">
      <option-senior-input
        class="text-center"
        v-model="innerTitle"
        size="base"
        placeholder="请填写任务书标题"
        placeholder-align="center"
        allowEmpty
        :seniors="[]"
        :senior-editor-toolbar="[['fontsizeselect'], ['alignleft aligncenter alignright alignjustify'], ['removeformat']]"
        senior-editor-default-style="text-align:center;font-size:20px"
        preText="请填写问卷调查标题"
        ref="surveyTitle"
        @blur="onBlurTitle"
      />
    </div>
    <div class="title flex justify-between items-center">
      <span>通用文案</span>
      <template v-if="readonly">
        <el-button type="primary" @click="readonly=!readonly">编辑</el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="saveContent">保存</el-button>
      </template>
    </div>
    <div class="content mb-5 relative">
      <SeniorEditor v-model="innerContent" :readonly="readonly && !!innerContent" image :placeholder='readonly?"点击“编辑”输入任务书通用文案":"请输入"'></SeniorEditor>
      <div v-if="readonly && !innerContent " class="absolute inset-0"></div>
    </div>
    <div class="title flex justify-between items-center">
      <span>定制附件</span>
      <el-button v-if="data.length" type="primary" @click="onUploadFile">继续上传</el-button>
    </div>
    <div class="content">
      <div class="tips">
          <span class="text-yellow-theme text-medium leading-22 mr-6">
            <span><i class="el-icon-warning-outline text-medium "></i></span>
            上传人员名单，可自定义不同人员的附件显示内容，例：任务明细数量、总价格等</span>
        <el-button type="text" @click="getTemplate">下载模版</el-button>
      </div>
      <template v-if="data.length">
        <div v-loading="tableLoading">
          <el-table :data="data">
            <el-table-column
              v-for="col in columns"
              :key="col.prop"
              v-bind="col"
              :label="col.label"
            />
          </el-table>
          <div class="mt-4 flex justify-end">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              :page-size="page.size"
              :current-page="page.current"
              @size-change="onSizeChange"
              @current-change="onCurrentChange"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="mt-2">
          <el-button type="primary" @click="onUploadFile">点击上传</el-button>
        </div>
      </template>

    </div>
  </div>
</template>

<style scoped lang="scss">
.title {
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 20px;
  margin-bottom: 16px;
}

.title-content {
  :deep(.senior-input) {
    .rich-text-input {
      border: 1px solid #DCDCDC !important;
    }
  }
}
</style>
